import type { BoxShopApiGateway } from "@/modules/boxShop/gateway/boxShopApiGateway"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import type { Page, Paginated } from "@/modules/utils/paginated"
import {
  BoxShopItemDtoSchema,
  BoxShopItemInputDtoSchema,
  type BoxShopItemCategory,
  type BoxShopItemDto,
  type BoxShopItemInputDto,
} from "@/modules/boxShop/gateway/boxShopApiDto"
import { toPage } from "@/modules/utils/paginated"

export class BoxShopApi implements BoxShopApiGateway {
  private shopApiUrl = `box/shop`

  constructor(private api: ApiClient) {}

  async getItems(
    category: BoxShopItemCategory | undefined,
    search: string | undefined,
    page: number | undefined,
    pageSize: number | undefined,
  ): Promise<Page<BoxShopItemDto>> {
    const response = await this.api.get<Paginated<BoxShopItemDto>>(`${this.shopApiUrl}/items`, {
      params: { page, size: pageSize, search, category, sort: "title,ASC" },
    })

    const pageData = toPage(response.data)
    return {
      ...pageData,
      content: pageData.content.map((item) => LoggerService.parseApiDto(BoxShopItemDtoSchema, item)),
    }
  }

  async createItem(item: BoxShopItemInputDto): Promise<BoxShopItemDto> {
    LoggerService.parseApiDto(BoxShopItemInputDtoSchema, item)
    const response = await this.api.post<BoxShopItemDto>(`${this.shopApiUrl}/items`, item)
    return LoggerService.parseApiDto(BoxShopItemDtoSchema, response.data)
  }

  async updateItem(id: string, item: BoxShopItemInputDto): Promise<BoxShopItemDto> {
    LoggerService.parseApiDto(BoxShopItemInputDtoSchema, item)
    const response = await this.api.post<BoxShopItemDto>(`${this.shopApiUrl}/items/${id}`, item)
    return LoggerService.parseApiDto(BoxShopItemDtoSchema, response.data)
  }

  async deleteItem(id: string): Promise<void> {
    await this.api.delete(`${this.shopApiUrl}/items/${id}`)
  }
}
